import { fetchTradeupProductsFromBackend, initDigitalDataTradeUpProducts } from './services';

export const loadTradeupProducts = async (mainProductInfo) => {
  const mainProductId = mainProductInfo.productID;
  const tradeUpProducts = await fetchTradeupProductsFromBackend(mainProductId);
  initDigitalDataTradeUpProducts(tradeUpProducts);
  return tradeUpProducts;
};
